import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/drafts");
  },
    
  async add(data) {
    await Csrf.getCookie();

    return Api.post("/drafts", data);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/drafts/"+id);
  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/drafts/"+id);
  },
};